import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from './services/authentication.service';
import { AuthorizationService } from './services/authorization.service';
import { LoadingService } from './services/loading.service';
import {Observable} from "rxjs";
import { InputTrimService } from './services/input-trim.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'banking-app';
  loading$!: Observable<boolean>;

  constructor(public authenticationService: AuthenticationService,
    public authorizationService: AuthorizationService,
    public loadingService: LoadingService,
    inputTrimService: InputTrimService
  ) {
    void inputTrimService;
  }

  ngOnInit(): void {
    this.loading$ = this.loadingService.loading$;
  }

}
